import * as THREE from 'three';
import { buildWallRegionFromRooms } from '../WallRegionBuilder';

/**
 * Wall thickness assumed around rooms whose floor has no outline: the same
 * default the outline tool and the export's "create outline" use.
 */
export const DEFAULT_AS_BUILT_WALL_THICKNESS_M = 0.3;

export interface OutlineRings2D {
  outerRing: { x: number; y: number }[];
  holes: { x: number; y: number }[][];
}

/**
 * The as-built outline of a floor that has none drawn or merged: the rooms
 * buffered by a default wall thickness, one ring component per connected group
 * of rooms, holes included. So a floor converted from its rooms alone still has
 * a wall band (outline ⊖ rooms) to render in 2D and 3D, to measure openings
 * against and to export — the same band "create outline" would write, without
 * writing it. Empty when the floor has no rooms.
 */
export function deriveOutlineRingsFromRooms(rooms: ReadonlyArray<{ identifier: string; getPolygon(): THREE.Vector3[] }>): OutlineRings2D[] {
  const roomData = rooms.map((room) => ({ identifier: room.identifier, polygon: room.getPolygon() })).filter((room) => room.polygon.length >= 3);
  if (roomData.length === 0) return [];
  return buildWallRegionFromRooms(roomData, DEFAULT_AS_BUILT_WALL_THICKNESS_M)
    .filter((component) => component.outerRing.length >= 3)
    .map((component) => ({
      outerRing: component.outerRing.map((v) => ({ x: v.x, y: v.y })),
      holes: component.holes.filter((ring) => ring.length >= 3).map((ring) => ring.map((v) => ({ x: v.x, y: v.y }))),
    }));
}
